import React from "react";
import { SpinnerOverlay, SpinnerRing, BrandMark } from "./with-spinner.styles";

const Loader = () => {
  return (
    <SpinnerOverlay>
      <SpinnerRing />
      <BrandMark>
        Topilov<span>.</span>
      </BrandMark>
    </SpinnerOverlay>
  );
};

export default Loader;
